import React, { FunctionComponent } from "react";
import {
  Typography, Box
} from "@mui/material";

const Footer: FunctionComponent = () => {
  return (
    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', width: '100%' }}>
      <Typography variant="body2" align="center" sx={{ flex: 1 }}>
        Copyright © <strong style={{ color: "#d01e42" }}>Barksdale</strong>. All rights reserved.
      </Typography>
      <Typography variant="body2" sx={{ position: 'absolute', right: 16, color: '#888', fontSize: 13 }}>
        {/* Version: 1.0.5 - yet to push last version build to production*/}
         Version: 1.1.5
       
      </Typography>
    </Box>
  );
};

export default Footer;

